import React, { useEffect, useState } from 'react';
import './contactStyle.css';
import { IoLogoWhatsapp } from "react-icons/io";
import { MdOutlineEmail } from "react-icons/md";
import { FaLinkedin } from "react-icons/fa";
import H2Title from './../../../../components/text/h2Title/h2Title'
import NormalText from './../../../../components/text/normalText'

export default function Contact({title, email, linkedin, whatsapp, text}) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const handleResize = () => {
        setWindowWidth(window.innerWidth)
    };

    useEffect ( () => {
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [])

    return (
        <section className='contact__container'>
            <H2Title title={title} color={"white"} width={(windowWidth < 769) ? "100%" : "min-content"}/>
            
            <div className='contact__content'>
                
               <div className='contact_icons-area'>
                    <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer"><MdOutlineEmail className="icon-link" color="black"/></a>
                    <a href={`https://wa.me/${whatsapp}`} target="_blank" rel="noopener noreferrer"><IoLogoWhatsapp className="icon-link" color="black"/></a>
                    <a href={linkedin} target="_blank" rel="noopener noreferrer"><FaLinkedin className="icon-link" color="black"/></a>
               </div>

               <NormalText text={text} />

            </div>

        </section>
    );
}
